import { render, staticRenderFns } from "./SideBox.vue?vue&type=template&id=2400217b&scoped=true&"
import script from "./SideBox.vue?vue&type=script&lang=js&"
export * from "./SideBox.vue?vue&type=script&lang=js&"
import style0 from "./SideBox.vue?vue&type=style&index=0&id=2400217b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2400217b",
  null
  
)

export default component.exports